exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mtg-logo-text[data-v-73458bee]:hover{cursor:pointer;fill:#e4454a}", ""]);

// exports
